function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6954 15.0359C22.2779 15.0359 28.4386 24.0401 28.4386 34.9399C28.4386 45.8397 22.2779 54.8439 14.6954 54.8439C7.11291 54.8439 0.952148 45.8397 0.952148 34.9399C0.952148 24.0401 7.11291 15.0359 14.6954 15.0359ZM15.1693 52.9482C9.48243 42.0484 22.2779 32.0965 15.1693 16.9315C18.0127 38.7311 6.639 41.1006 15.1693 52.9482Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.3865 27.3574C44.0775 24.9879 62.0859 46.3136 52.1339 57.2134C44.5514 65.2698 30.8082 58.1612 25.1213 51.0526C28.4387 46.7875 30.3343 41.1006 30.3343 36.3616C40.7602 46.3136 38.3907 54.37 51.1861 55.7917C41.2341 53.4221 40.7602 41.1006 30.3343 33.9921C30.3343 31.6225 29.8604 29.253 29.3865 27.3574Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.447 2.24045C50.7122 5.55779 50.2383 13.6142 45.0253 19.301C40.2863 25.4618 32.7038 27.3574 28.4387 24.0401C24.1735 20.7227 24.6474 12.6664 29.8604 6.9795C34.5994 0.818741 42.1819 -1.07688 46.447 2.24045ZM29.3865 23.5662C31.2821 15.0359 42.6558 15.5098 45.9731 3.18826C37.9168 16.4576 30.3343 12.6664 29.3865 23.5662Z",
  fill: "black"
});

function SvgCardbeans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 61,
    viewBox: "0 0 55 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardbeans);
export default __webpack_public_path__ + "static/media/cardbeans.013d0699.svg";
export { ForwardRef as ReactComponent };